import { NavLink } from 'react-router-dom';
import { ProfileMenu } from './ProfileMenu';
import { useApp } from '../helpers/api-helpers';
import logo from '../icons/logo-inline.svg';
import styles from './DesktopAppHeader.module.css';
import { PurchaseCTA } from './PurchaseCTA';

export function DesktopAppHeader() {
  const { tabs, user, authState, branding } = useApp();

  return (
    <header className={styles.wrapper}>
      <NavLink className={styles.logo} to="/">
        <img
          className={branding?.logoUrl ? styles.brandedLogo : undefined}
          src={branding?.logoUrl ?? logo}
          alt={branding?.name ?? 'Recademics'}
        />
        {branding?.id && (
          <span className={styles.poweredBy}>Powered by Recademics</span>
        )}
      </NavLink>
      <nav className={styles.tabs}>
        {user && (
          <ul>
            {tabs.map(({ path, title }) => (
              <li key={path}>
                <NavLink to={path}>{title}</NavLink>
              </li>
            ))}
          </ul>
        )}
      </nav>
      {user && <ProfileMenu className={styles.profileMenu} />}
      {authState === 'signIn' && <PurchaseCTA className={styles.purchaseCTA} />}
    </header>
  );
}
